/* eslint-disable no-empty-pattern */
import React from 'react';
import { Wrapper } from './CampaignOversightDetails.Styles';
import { CampaignOversightForm } from './CampaignOversightForm';
export var CampaignOversightDetails = function (_a, props) {
    var selectedScheduleExecution = _a.selectedScheduleExecution, controlScheduleExecution = _a.controlScheduleExecution, onDiscardClick = _a.onDiscardClick, dialerDefaults = _a.dialerDefaults, onAccountChange = _a.onAccountChange, schedules = _a.schedules;
    return (React.createElement(Wrapper, null,
        React.createElement(CampaignOversightForm, { dialerDefaults: dialerDefaults, onDiscardClick: onDiscardClick, selectedRow: selectedScheduleExecution, schedules: schedules, controlScheduleExecution: function (action, scheduleExecutionId, callback, pacing) {
                return controlScheduleExecution(action, scheduleExecutionId, callback, pacing);
            }, onAccountChange: function (url) { return onAccountChange(url); } })));
};
CampaignOversightDetails.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CampaignOversightDetails.js.map